export const PIP_STASH_COMMAND_TYPE = 'ced.pip_stash';

export function parsePiPStashCommand(payload) {
  if (!payload || payload.senderId == null || typeof payload.text !== 'string') {
    return null;
  }

  try {
    const command = JSON.parse(payload.text);
    if (
      !command ||
      command.type !== PIP_STASH_COMMAND_TYPE ||
      typeof command.stashed !== 'boolean'
    ) {
      return null;
    }

    return {
      senderId: String(payload.senderId),
      stashed: command.stashed,
    };
  } catch (e) {
    return null;
  }
}

/**
 * iOS keeps the Zoom video on while its PiP is stashed at the screen edge, so the
 * frame freezes. Show those users with the camera off.
 */
export function applyPiPStashState(users, stashedUserIds) {
  if (!Array.isArray(users)) {
    return [];
  }
  if (!stashedUserIds || stashedUserIds.size === 0) {
    return users;
  }

  return users.map((user) =>
    stashedUserIds.has(String(user.userId))
      ? { ...user, isVideoOn: false, bVideoOn: false }
      : user,
  );
}
